import type { FC } from "react";
import { useCallback } from "react";
import ShakeEffectView from "@/components/animatableView/shakeEffectView";
import useTimeoutTrigger from "@/hooks/useTimeoutTrigger";
import { shakeEffectClassNames } from "@/components/animatableView/utils";

export const useShakeEffect = (opts: { fullWidth?: boolean } | undefined = undefined) => {
  const [showShakeEffect, runShakeEffect] = useTimeoutTrigger(300);

  const ShakeEffectWrapper: FC = useCallback(
    ({ children }) => (
      <ShakeEffectView fullWidth={opts?.fullWidth} showEffect={showShakeEffect}>
        {children}
      </ShakeEffectView>
    ),
    [showShakeEffect, opts]
  );

  return {
    className: shakeEffectClassNames(showShakeEffect),
    runShakeEffect,
    ShakeEffectWrapper,
    showShakeEffect
  };
};
